import { useState } from 'react';
import { EditProduct } from '../../pages/products/edit';
import { PrimaryButton, SecondaryButton } from '../buttons';
import { Modal } from '../modal';
import { Spinner } from '../spinner';
import { useProductEditStore } from './product-edit-modal-store';

export function ProductEditModalPortal() {
  const product = useProductEditStore((s) => s.editing);
  const stopEditing = useProductEditStore((s) => s.stopEditing);
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!product) {
    return null;
  }

  return (
    <Modal
      title={`${product.brand} | ${product.description}`}
      visible
      onClose={stopEditing}
      footer={
        <>
          <SecondaryButton onClick={stopEditing}>Cancel</SecondaryButton>
          <PrimaryButton type="submit" form="edit-product-form" disabled={isSubmitting}>
            {isSubmitting && <Spinner />}
            Update
          </PrimaryButton>
        </>
      }
    >
      <EditProduct product={product} onClose={stopEditing} onSubmittingChange={setIsSubmitting} />
    </Modal>
  );
}
